import { Injectable, Optional } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import {
	Notification,
	ErrorNotification,
	WarningNotification,
	InfoNotification,
	BusyNotification,
	Offsets,
	DockPosition
} from "./notification.class";
import { NotificationType } from "./notifications.enum";
import { NotificationConfig } from "./notification.config";

@Injectable({
	providedIn: "root"
})
export class NotificationService {
	raiseNotification$: BehaviorSubject<Notification>;
	clearNotification$: BehaviorSubject<string>;
	clearTypeNotifications$: BehaviorSubject<NotificationType | "all">;
	positionAdjustment$: BehaviorSubject<{
		dockPosition: DockPosition;
		offsets: Offsets;
	}>;
	private __config: NotificationConfig;

	constructor(@Optional() config: NotificationConfig) {
		this.raiseNotification$ = new BehaviorSubject<Notification>(undefined);
		this.clearNotification$ = new BehaviorSubject<string>(undefined);
		this.clearTypeNotifications$ = new BehaviorSubject(undefined);
		this.positionAdjustment$ = new BehaviorSubject(undefined);

		if (config) {
			this.__config = config;
		}
	}

	notifyError(
		errorMessage: string,
		title?: string,
		waitTime?: number
	): string {
		const error = new ErrorNotification(
			errorMessage,
			title,
			this.__config,
			waitTime
		);
		this.raiseNotification$.next(error);
		return error.id;
	}

	notifyWarning(
		warnMessage: string,
		title?: string,
		waitTime?: number
	): string {
		const warn = new WarningNotification(
			warnMessage,
			title,
			this.__config,
			waitTime
		);
		this.raiseNotification$.next(warn);
		return warn.id;
	}

	notifyInfo(infoMessage: string, title: string, waitTime?: number): string {
		const info = new InfoNotification(
			infoMessage,
			title,
			this.__config,
			waitTime
		);
		this.raiseNotification$.next(info);
		return info.id;
	}

	notifyBusy(busyMessage: string, title: string, waitTime?: number): string {
		const busy = new BusyNotification(
			busyMessage,
			title,
			this.__config,
			waitTime
		);
		this.raiseNotification$.next(busy);
		return busy.id;
	}

	clearNotification(notificationId: string) {
		this.clearNotification$.next(notificationId);
	}

	clearNotificationsOfType(notificaionType: NotificationType | "all") {
		this.clearTypeNotifications$.next(notificaionType);
	}

	adjustPosition(position: {
		dockPosition?: DockPosition;
		offsets?: Offsets;
	}) {
		this.positionAdjustment$.next({
			dockPosition: position.dockPosition,
			offsets: position.offsets
		});
	}
}
